export enum IFilterMode {
  filter = 'filter',
  axis = 'axis'
}
